import { useEffect, useMemo } from 'react';
import { useLanguage } from '~/Hooks';
import { useAuth } from '~/store/auth';
import { LoginFormState } from './components/LoginForm';
import CONFIG from '~/Config/env.config';
import { EnvironmentHelper } from '~/Helpers/Environment.helpers';

export const useLogin = () => {
  const { login, isLoading, error } = useAuth();
  const { t } = useLanguage();

  useEffect(() => {
    const { isProduction, hasURLTestEnvironment } = EnvironmentHelper();

    //Add oneTrust cookie banner for production only and exclude all test environments
    if (document.head && isProduction && !hasURLTestEnvironment) {
      const oneTrustscript = document.createElement('script');
      oneTrustscript.async = true;
      oneTrustscript.src = CONFIG.ONE_TRUST_URL;
      oneTrustscript.type = 'text/javascript';
      oneTrustscript.charset = 'UTF-8';
      oneTrustscript.setAttribute('data-domain-script', CONFIG.ONE_TRUST_KEY);
      oneTrustscript.innerHTML = 'function OptanonWrapper() { };';
      document.head.prepend(oneTrustscript);
    }
  }, []);

  const onLoginFormSubmit = useMemo(
    () => (data: LoginFormState) =>
      login({
        username: data.email,
        password: data.password,
      }),
    [],
  );

  return {
    error,
    isLoginLoading: isLoading,
    onLoginFormSubmit,
    t,
  };
};
